import React, { createContext, useContext, useState, useEffect } from 'react';
import firebaseService from '../services/firebaseService';


const DataContext = createContext();

export const useSiteData = () => useContext(DataContext);

export const DataProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [settings, setSettings] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Subscribe to Firebase real-time updates for content
    const unsubscribe = firebaseService.subscribeToSiteContent((result) => {
      if (result.success) {
        if (result.products) {
          const uniqueProducts = result.products.filter((v,i,a)=>a.findIndex(t=>(t.name === v.name))===i);
          setProducts(uniqueProducts);
        }
        if (result.categories) {
          const uniqueCategories = result.categories.filter((v,i,a)=>a.findIndex(t=>(t.name === v.name))===i);
          setCategories(uniqueCategories);
        }
        if (result.settings) {
          setSettings(result.settings);
        }
      }
      setIsLoading(false);
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  const getProductsByCategory = (categoryId) => {
    return products.filter(product => product.categoryId === categoryId);
  };

  const getProductById = (productId) => {
    return products.find(product => product.id === productId || product._dbId === productId);
  };

  const getCategoryById = (categoryId) => {
    return categories.find(category => category.id === categoryId || category._dbId === categoryId);
  };

  const value = {
    products,
    categories,
    settings,
    isLoading,
    getProductsByCategory,
    getProductById,
    getCategoryById
  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};
